import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { createQuote } from '../../../services/salesQuotesService';

const CreateQuoteForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Explicitly define form state type
  const [formData, setFormData] = useState<{
    quoted_amount: string;
    tax_rate: string;
    discount: string;
    valid_until: string;
    status: string;
    file: File | null;
  }>({
    quoted_amount: '',
    tax_rate: '',
    discount: '',
    valid_until: '',
    status: 'pending', // Default status
    file: null
  });

  // Handle input change
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: name === 'quoted_amount' ? (value ? Number(value) : '') : value // Convert amount to number
    }));
  };

  // Handle file change
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    setFormData(prevState => ({ ...prevState, file: selectedFile }));
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    formDataToSend.append('crm_institute_id', id!);
    formDataToSend.append('quoted_amount', formData.quoted_amount);
    formDataToSend.append('tax_id', formData.tax_rate);
    formDataToSend.append('discount', formData.discount);
    formDataToSend.append('valid_until', formData.valid_until);
    formDataToSend.append('status', formData.status);

    if (formData.file) {
      formDataToSend.append('document', formData.file);
    }

    try {
      await createQuote(formDataToSend);
      alert('Quote created successfully');
      navigate('/crm/opportunities');
    } catch (error) {
      console.error('Error creating quote:', error);
    }
  };

  return (
    <div className="container">
      <h2>Create Quote</h2>
      <Form onSubmit={handleSubmit}>
        {/* Quoted Amount Field */}
        <Form.Group>
          <Form.Label>Quoted Amount</Form.Label>
          <Form.Control
            type="number"
            name="quoted_amount"
            value={formData.quoted_amount.toString()} // Ensure valid input
            onChange={handleChange}
            required
          />
        </Form.Group>

        {/* Tax Rate Field */}
        <Form.Group>
          <Form.Label>Tax Rate</Form.Label>
          <Form.Select
            name="tax_rate"
            value={formData.tax_rate}
            onChange={handleChange}
          >
            <option value="1">5%</option>
            <option value="2">10%</option>
          </Form.Select>
        </Form.Group>

        {/* Discount Field */}
        <Form.Group>
          <Form.Label>Discount</Form.Label>
          <Form.Select
            name="discount"
            value={formData.discount}
            onChange={handleChange}
          >
            <option value="1">None</option>
            <option value="2">10%</option>
          </Form.Select>
        </Form.Group>

        {/* Valid Until Field */}
        <Form.Group>
          <Form.Label>Valid Until</Form.Label>
          <Form.Control
            type="date"
            name="valid_until"
            value={formData.valid_until}
            onChange={handleChange}
            required
          />
        </Form.Group>

        {/* Status Field */}
        <Form.Group>
          <Form.Label>Status</Form.Label>
          <Form.Select
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </Form.Select>
        </Form.Group>

        {/* File Upload Field */}
        {/* <Form.Group>
          <Form.Label>Upload Quote Document</Form.Label>
          <Form.Control type="file" name="file" onChange={handleFileChange} />
        </Form.Group> */}

        {/* Submit Button */}
        <Button type="submit" className="mt-3">
          Create Quote
        </Button>
      </Form>
    </div>
  );
};

export default CreateQuoteForm;
